import { useMemo, useRef } from 'react'
import { DndProvider } from '@minoru/react-dnd-treeview'
import { HTML5Backend } from 'react-dnd-html5-backend'

const DndProviderWrapper = ({ className, children, style, disableBuffer }) => {
  const context = useRef(null)
  const dndArea = context.current
  const html5Options = useMemo(() => ({ rootElement: dndArea }), [dndArea])
  return (
    <div className={className} ref={context} style={style}>
      {(dndArea || disableBuffer) && (
        <DndProvider backend={HTML5Backend} options={html5Options}>
          {children}
        </DndProvider>
      )}
    </div>
  )
}

export default DndProviderWrapper
